import { render, staticRenderFns } from "./Giftcards.vue?vue&type=template&id=41d6754b&"
import script from "./Giftcards.vue?vue&type=script&lang=js&"
export * from "./Giftcards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports